import classes from "../homePageNew.module.css";
import { ArrowLeftIcon, ArrowRightIcon } from "./icons";

/**
 * Pure presentational port of the prototype's pagerA() — "Prev/Next + Range".
 * Driven entirely by props so the same component works whether the numbers
 * come from the main paginated list or an active search.
 */
export default function PaginationBar({ page, totalPages, total, start, count, onPageChange }) {
  const rangeLabel = count ? `${start + 1}–${start + count} of ${total}` : "0 of 0";
  return (
    <div className={classes.pagerA}>
      <span className={classes.rng}>{rangeLabel}</span>
      <div style={{ display: "flex", gap: 6 }}>
        <button
          className={classes.pagerArrow}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <ArrowLeftIcon size={14} />
        </button>
        <button
          className={classes.pagerArrow}
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <ArrowRightIcon size={14} />
        </button>
      </div>
    </div>
  );
}
